/*global google*/

import React from 'react';
import {Link, withRouter} from 'react-router-dom';

import Geosuggest from 'react-geosuggest';
import LocalizedStrings from 'react-localization';

import {CustomDatePicker} from './components/CustomDatePicker';
import localStorage from '../Common/LocalStorage';
import {UserRole} from '../Common/UserRole';

import Svgs from '../Common/Svgs';
//import Images from '../Common/Images';
import {
    Input,
    MainBtn,
    CancelBtn,
    EditPharmacyAdminSelect,
    EditPharmacyOwnerSelect,
    EditPharmacyManagerSelect
} from '../Common/form/Elements-export';
import {translations} from '../Common/Translations';
import {StaticRoutePaths} from '../Common/ClientRoutes';

import {editPatient} from './epics-patients';
import {geoCodeAddress} from "../Common/Helpers";

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

class EditPatient extends React.Component {
    constructor(props) {
        super(props);
        // console.log(this.props.patientDetails.dateOfBirth);
        // let dateObj = new Date(this.props.patientDetails.dateOfBirth);
        // let displayDate = ('0' + dateObj.getDate()).slice(-2) + '/'
        //     + ('0' + (dateObj.getMonth() + 1)).slice(-2) + '/'
        //     + dateObj.getFullYear();
        this.state = {
            loadingSpinner: false,
            patientId: this.props.patientDetails.id,
            username: this.props.patientDetails.name,
            birthday: this.props.patientDetails.dateOfBirth ? this.props.patientDetails.dateOfBirth : null,
            birthdayValue: this.props.patientDetails.dateOfBirth ? this.props.patientDetails.dateOfBirth : null,
            insuranceCardWarning: '',
            secondInsuranceCardWarning: '',
            insuranceCard: this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.primaryCardNumber
                ? this.props.patientDetails.insuranceCards.primaryCardNumber
                : '',
            // primaryCardImageURL: this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.primaryCardImageURL
            //   ? this.props.patientDetails.insuranceCards.primaryCardImageURL
            //   : Images.UPLOAD_PLACEHOLDER,
            // primaryCardBackImageURL:  this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.primaryCardBackImageURL
            //   ? this.props.patientDetails.insuranceCards.primaryCardBackImageURL
            //   : Images.UPLOAD_PLACEHOLDER,
            // has_primaryCardImageURL: !!(this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.primaryCardImageURL),
            // has_primaryCardBackImageURL: !!(this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.primaryCardBackImageURL),
            secondInsuranceCard: this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.secondaryCardNumber
                ? this.props.patientDetails.insuranceCards.secondaryCardNumber
                : '',
            // secondaryCardImageURL: this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.secondaryCardImageURL
            //   ? this.props.patientDetails.insuranceCards.secondaryCardImageURL
            //   : Images.UPLOAD_PLACEHOLDER,
            // secondaryCardBackImageURL:  this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.secondaryCardBackImageURL
            //   ? this.props.patientDetails.insuranceCards.secondaryCardBackImageURL
            //   : Images.UPLOAD_PLACEHOLDER,
            // has_secondaryCardImageURL: !!(this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.secondaryCardImageURL),
            // has_secondaryCardBackImageURL: !!(this.props.patientDetails.insuranceCards && this.props.patientDetails.insuranceCards.secondaryCardBackImageURL),
            pharmacy: this.props.patientDetails.pharmacy.name,
            pharmacyId: this.props.patientDetails.pharmacy.id,
            email: this.props.patientDetails.email,
            phone: this.props.patientDetails.phone,
            address: {
                name: this.props.patientDetails ? this.props.patientDetails.address.name : ' ',
                latitude: this.props.patientDetails ? this.props.patientDetails.address.latitude : ' ',
                longitude: this.props.patientDetails ? this.props.patientDetails.address.longitude : ' '
            },
            validation: {
                username: '',
                birthday: '',
                insuranceCard: '',
                secondInsuranceCard: '',
                pharmacy: '',
                email: '',
                phone: '',
                address: '',
                internalServerError: ''
            }
        };
    }

    update = type => e => {
        this.setState({...this.state, [type]: e.target.value});
    };

    updateInsuranceCardNumber = type => e => {
        let regexInsuranceNumber = /^(8075)([0-9]{16})$/g,
            regexOnlyDigits = /^[0-9]*$/g,
            strFirstFour = e.target.value.substring(0, 4),
            warningMessage = this.state.insuranceCardWarning ? this.state.insuranceCardWarning : '',
            insuranceCardNumber = e.target.value;

        if (e.target.value !== '') {
            if (!regexOnlyDigits.test(e.target.value)) {
                insuranceCardNumber = e.target.value.substring(0, e.target.value.length - 1);
                e.target.value = insuranceCardNumber;
            } else if (e.target.value.length >= 4) {
                if (strFirstFour !== '8075' && e.target.value.length <= 20) {
                    warningMessage = strings.insurance_card_warning_1;
                }
                if (strFirstFour !== '8075' && e.target.value.length > 20) {
                    warningMessage = strings.insurance_card_warning_2;
                }
                if (strFirstFour === '8075' && e.target.value.length !== 20) {
                    warningMessage = strings.insurance_card_warning_3;
                }
                if (regexInsuranceNumber.test(e.target.value)) {
                    warningMessage = '';
                }
            }
        } else {
            warningMessage = '';
        }

        this.setState({
            ...this.state,
            [type]: insuranceCardNumber,
            [type + 'Warning']: warningMessage
        })

    };

    getDateHandler = date => {
        let displayDate = ('0' + date.getDate()).slice(-2) + '/'
            + ('0' + (date.getMonth() + 1)).slice(-2) + '/'
            + date.getFullYear();
        if (this.refs.myRef) {
            this.setState({...this.state, birthday: date, birthdayValue: date !== null ? displayDate : null});
        }
    };

    // handleImageUpload = (clickedImage) => {
    //   this[clickedImage].click();
    // };
    //
    // handleImageChange = e => {
    //   let currentElement = e.target.name;
    //   let reader = new FileReader();
    //   let file = e.target.files[0];
    //
    //   reader.onloadend = () => {
    //     this.setState({
    //       ...this.state,
    //       [currentElement]: reader.result,
    //       ['has_' + currentElement]: true
    //     });
    //   };
    //
    //   if (e.target.files[0]) {
    //     reader.readAsDataURL(file);
    //   }
    // };
    //
    // removeImage = (e, image) => {
    //   e.preventDefault();
    //   this.setState({
    //     ...this.state,
    //     [image]: Images.UPLOAD_PLACEHOLDER,
    //     ['has_' + image]: false
    //   });
    // };

    updateAddress = address => {
        let addressName = address,
            self = this;

        if (addressName.trim() !== '') {
            geoCodeAddress(addressName).then(latlong => {
                self.setState({
                    ...self.state,
                    address: {
                        name: addressName,
                        latitude: latlong !== 'no results' ? latlong.lat.toString() : '0.00',
                        longitude: latlong !== 'no results' ? latlong.lng.toString() : '0.00'
                    }
                });
            });
        } else {
            this.setState({
                ...this.state,
                address: {
                    name: '',
                    latitude: '',
                    longitude: ''
                }
            });
        }
    };

    onSuggestSelect = suggest => {
        if (suggest !== undefined) {
            this.setState({
                ...this.state,
                address: {
                    name: suggest.label ? suggest.label : '',
                    latitude: (suggest.location && suggest.location.lat) ? suggest.location.lat.toString() : '0.00',
                    longitude: (suggest.location && suggest.location.lat) ? suggest.location.lng.toString() : '0.00'
                }
            });
        }
    };

    cancelUserHandler = () => {
        this.props.history.push(StaticRoutePaths.PATIENTS);
    };

    editPatientHandler = () => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });

        editPatient(this.state.patientId, this.state)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                this.props.history.push(StaticRoutePaths.PATIENTS);
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    insuranceCardWarning: '',
                    secondInsuranceCardWarning: '',
                    validation: {
                        username: this.errorServerCatcher(error.body, 'name'),
                        birthday: this.errorServerCatcher(error.body, 'dateOfBirth'),
                        pharmacy: this.errorServerCatcher(error.body, 'pharmacy'),
                        email: this.errorServerCatcher(error.body, 'email'),
                        phone: this.errorServerCatcher(error.body, 'phone'),
                        address: this.errorServerCatcher(error.body, 'address'),
                        insuranceCard: this.errorServerCatcher(error.body, 'insuranceCards'),
                        secondInsuranceCard: this.errorServerCatcher(error.body, 'secondInsuranceCard')
                    }
                });
            });
    };

    generatePharmacySelect = userRole => {
        switch (userRole) {
            case UserRole.ADMIN:
                return (
                    <EditPharmacyAdminSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacyId')}
                        role={this.state.role}
                        pharmacyId={this.state.pharmacyId}
                        placeholder={this.props.patientDetails.pharmacy ? this.props.patientDetails.pharmacy.name : strings.Select_pharmacy}
                        extraClasses="col-8"
                    />
                );
            case UserRole.STORE_OWNER:
                return (
                    <EditPharmacyOwnerSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacyId')}
                        pharmacyId={this.state.pharmacyId}
                        placeholder={this.props.patientDetails.pharmacy ? this.props.patientDetails.pharmacy.name : strings.Select_pharmacy}
                        extraClasses="col-8"
                    />
                );
            case UserRole.PHARMACY_MANAGER:
                return (
                    <EditPharmacyManagerSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacyId')}
                        pharmacyId={this.state.pharmacyId}
                        placeholder={this.props.patientDetails.pharmacy ? this.props.patientDetails.pharmacy.name : strings.Select_pharmacy}
                        extraClasses="col-8"
                    />
                );
            case UserRole.PHARMACIST:
                return (
                    <EditPharmacyManagerSelect
                        {...this.props}
                        type="pharmacy"
                        label={`* ${strings.Pharmacy}`}
                        handler={this.update('pharmacyId')}
                        pharmacyId={this.state.pharmacyId}
                        placeholder={this.props.patientDetails.pharmacy ? this.props.patientDetails.pharmacy.name : strings.Select_pharmacy}
                        extraClasses="col-8"
                    />
                );
            default:
                return;
        }
    };

    errorServerCatcher = (errArray, errName) => {
        if (errArray.error !== undefined && errArray.error.code === 500) {
            this.setState({
                ...this.state,
                validation: {
                    ...this.state.validation,
                    internalServerError: 'internal server error'
                }
            });
            return 0;
        } else {
            return (
                this.generateErrorMessage(errArray, errName)
                    .join(' ')
                    .trim() || ''
            );
        }
    };

    generateErrorMessage = (errArray, errName) => {
        if (errArray !== null) {
            return (errArray || []).map(singleErr => {
                return singleErr.property_path === errName ? singleErr.message : '';
            });
        }
    };

    showErrors = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    getPharmacyIdHandler = () => (this.props.pharmacyList.pharmacies.length !== 0 ? this.props.pharmacyList.pharmacies[0].id : '');

    getPharmacyNameHandler = () =>
        this.props.pharmacyList.pharmacies.length !== 0 ? this.props.pharmacyList.pharmacies[0].name : 'No pharmacy';

    componentDidMount() {
        if (this.props.status === UserRole.PHARMACY_MANAGER) {
            this.setState({
                ...this.state,
                pharmacy: this.getPharmacyIdHandler()
            });
        }
    }

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.patients}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title text-capitalize">
                                    <i className="fa fa-plus-square mr-2"/>
                                    {strings.Edit_patient}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.PATIENTS} className="qf-back-btn">
                                    <i className="fa fa-chevron-left"/>
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line"/>
                            </div>
                        </div>
                        <div className="row" ref="myRef">
                            <Input
                                value={this.state.username}
                                handler={this.update('username')}
                                label={`* ${strings.Name}`}
                                placeholder={strings.patient_name_placeholder}
                                extraClasses="col-8"
                            />
                            <CustomDatePicker
                                extraClass="formInput col-4"
                                lable={`* ${strings.Birthday}`}
                                placeholder={strings.patient_birthday_placeholder}
                                getDateHandler={this.getDateHandler}
                                selectedDate={this.state.birthday}
                            />
                            <div className="col-8">{this.showErrors(this.state.validation.username)}</div>
                            <div className="col-4">{this.showErrors(this.state.validation.birthday)}</div>
                        </div>

                        <div className="row">
                            <Input
                                value={this.state.insuranceCard}
                                handler={this.updateInsuranceCardNumber('insuranceCard')}
                                label={`${strings.Insurance_card}`}
                                placeholder={strings.patient_insurance_card_placeholder}
                                extraClasses="col-6"
                            />
                            <Input
                                value={this.state.secondInsuranceCard}
                                handler={this.updateInsuranceCardNumber('secondInsuranceCard')}
                                label={`${strings.Second_insurance_card}`}
                                placeholder={strings.patient_insurance_card_2_placeholder}
                                extraClasses="col-6"
                            />
                            {/* <div className="col-6" style={{color: 'var(--danger)'}}>{this.state.insuranceCardWarning}</div>
              <div className="col-6" style={{color: 'var(--danger)'}}>{this.state.secondInsuranceCardWarning}</div>
              <div className="col-6">{this.showErrors(this.state.validation.insuranceCard)}</div>
              <div className="col-6">{this.showErrors(this.state.validation.secondInsuranceCard)}</div> */}
                        </div>

                        {/*<div className="row color-dark-gray">*/}
                        {/*  <div className="col-6 formInput">*/}
                        {/*    <label>*/}
                        {/*      {strings.insurance_card_photos}*/}
                        {/*    </label>*/}
                        {/*  </div>*/}
                        {/*  <div className="col-6 formInput">*/}
                        {/*    <label>*/}
                        {/*      {strings.second_insurance_card_photos}*/}
                        {/*    </label>*/}
                        {/*  </div>*/}
                        {/*  <div className="col-3">*/}
                        {/*    <div className="row">*/}
                        {/*      <div className="col-12">*/}
                        {/*        {strings.front_side}*/}
                        {/*        {this.state.has_primaryCardImageURL ? (*/}
                        {/*          <a onClick={(e) => this.removeImage(e, 'primaryCardImageURL')}*/}
                        {/*             className="pull-right qf-reset-image-btn">*/}
                        {/*            {strings.reset}*/}
                        {/*          </a>*/}
                        {/*        ) : null}*/}
                        {/*      </div>*/}
                        {/*      <div className="col-12">*/}
                        {/*        <div className="qf-upload-div">*/}
                        {/*          <a className="qf-upload-a mt-1"*/}
                        {/*             onClick={() => this.handleImageUpload('primaryCardImage')}>*/}
                        {/*            <img*/}
                        {/*              src={this.state.primaryCardImageURL}*/}
                        {/*              alt="Primary card front"*/}
                        {/*              className="qf-background-pharmacy img-fluid mb-1"*/}
                        {/*            />*/}
                        {/*          </a>*/}
                        {/*        </div>*/}
                        {/*        <input*/}
                        {/*          type="file"*/}
                        {/*          accept="image/png, image/jpeg"*/}
                        {/*          name="primaryCardImageURL"*/}
                        {/*          className="qf-hidden-element"*/}
                        {/*          id="primaryCardImage"*/}
                        {/*          ref={input => (this.primaryCardImage = input)}*/}
                        {/*          onChange={this.handleImageChange}*/}
                        {/*        />*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*  <div className="col-3">*/}
                        {/*    <div className="row">*/}
                        {/*      <div className="col-12">*/}
                        {/*        {strings.back_side}*/}
                        {/*        {this.state.has_primaryCardBackImageURL ? (*/}
                        {/*          <a onClick={(e) => this.removeImage(e, 'primaryCardBackImageURL')}*/}
                        {/*             className="pull-right qf-reset-image-btn">*/}
                        {/*            {strings.reset}*/}
                        {/*          </a>*/}
                        {/*        ) : null}*/}
                        {/*      </div>*/}
                        {/*      <div className="col-12">*/}
                        {/*        <div className="qf-upload-div">*/}
                        {/*          <a className="qf-upload-a mt-1"*/}
                        {/*             onClick={() => this.handleImageUpload('primaryCardBackImage')}>*/}
                        {/*            <img*/}
                        {/*              src={this.state.primaryCardBackImageURL}*/}
                        {/*              alt="Primary card front"*/}
                        {/*              className="qf-background-pharmacy img-fluid mb-1"*/}
                        {/*            />*/}
                        {/*          </a>*/}
                        {/*        </div>*/}
                        {/*        <input*/}
                        {/*          type="file"*/}
                        {/*          accept="image/png, image/jpeg"*/}
                        {/*          name="primaryCardBackImageURL"*/}
                        {/*          className="qf-hidden-element"*/}
                        {/*          id="primaryCardBackImage"*/}
                        {/*          ref={input => (this.primaryCardBackImage = input)}*/}
                        {/*          onChange={this.handleImageChange}*/}
                        {/*        />*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*  <div className="col-3">*/}
                        {/*    <div className="row">*/}
                        {/*      <div className="col-12">*/}
                        {/*        {strings.front_side}*/}
                        {/*        {this.state.has_secondaryCardImageURL ? (*/}
                        {/*          <a onClick={(e) => this.removeImage(e, 'secondaryCardImageURL')}*/}
                        {/*             className="pull-right qf-reset-image-btn">*/}
                        {/*            {strings.reset}*/}
                        {/*          </a>*/}
                        {/*        ) : null}*/}
                        {/*      </div>*/}
                        {/*      <div className="col-12">*/}
                        {/*        <div className="qf-upload-div">*/}
                        {/*          <a className="qf-upload-a mt-1"*/}
                        {/*             onClick={() => this.handleImageUpload('secondCardImage')}>*/}
                        {/*            <img*/}
                        {/*              src={this.state.secondaryCardImageURL}*/}
                        {/*              alt="Primary card front"*/}
                        {/*              className="qf-background-pharmacy img-fluid mb-1"*/}
                        {/*            />*/}
                        {/*          </a>*/}
                        {/*        </div>*/}
                        {/*        <input*/}
                        {/*          type="file"*/}
                        {/*          accept="image/png, image/jpeg"*/}
                        {/*          name="secondaryCardImageURL"*/}
                        {/*          className="qf-hidden-element"*/}
                        {/*          id="secondCardImage"*/}
                        {/*          ref={input => (this.secondCardImage = input)}*/}
                        {/*          onChange={this.handleImageChange}*/}
                        {/*        />*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*  <div className="col-3">*/}
                        {/*    <div className="row">*/}
                        {/*      <div className="col-12">*/}
                        {/*        {strings.back_side}*/}
                        {/*        {this.state.has_secondaryCardBackImageURL ? (*/}
                        {/*          <a onClick={(e) => this.removeImage(e, 'secondaryCardBackImageURL')}*/}
                        {/*             className="pull-right qf-reset-image-btn">*/}
                        {/*            {strings.reset}*/}
                        {/*          </a>*/}
                        {/*        ) : null}*/}
                        {/*      </div>*/}
                        {/*      <div className="col-12">*/}
                        {/*        <div className="qf-upload-div">*/}
                        {/*          <a className="qf-upload-a mt-1"*/}
                        {/*             onClick={() => this.handleImageUpload('secondaryCardBackImage')}>*/}
                        {/*            <img*/}
                        {/*              src={this.state.secondaryCardBackImageURL}*/}
                        {/*              alt="Primary card front"*/}
                        {/*              className="qf-background-pharmacy img-fluid mb-1"*/}
                        {/*            />*/}
                        {/*          </a>*/}
                        {/*        </div>*/}
                        {/*        <input*/}
                        {/*          type="file"*/}
                        {/*          accept="image/png, image/jpeg"*/}
                        {/*          name="secondaryCardBackImageURL"*/}
                        {/*          className="qf-hidden-element"*/}
                        {/*          id="secondaryCardBackImage"*/}
                        {/*          ref={input => (this.secondaryCardBackImage = input)}*/}
                        {/*          onChange={this.handleImageChange}*/}
                        {/*        />*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*</div>*/}
                        {/*<div className="row">*/}
                        {/*  <div className="col-12 color-dark-gray mb-1 mt-3 text-center">*/}
                        {/*    <span>{strings.formatString(strings.Optimal_size, { width: 750, height: 570 })} </span>*/}
                        {/*    <span>{strings.use_png}</span>*/}
                        {/*  </div>*/}
                        {/*</div>*/}

                        <div className="row">
                            {this.generatePharmacySelect(localStorage.getFromStorage('role'))}
                            <div className="col-8">{this.showErrors(this.state.validation.pharmacy)}</div>
                        </div>

                        <div className="row">
                            <Input
                                value={this.state.email}
                                handler={this.update('email')}
                                label={`* ${strings.Email}`}
                                placeholder={strings.patient_email_placeholder}
                                extraClasses="col-8"
                            />
                            <div className="col-8">{this.showErrors(this.state.validation.email)}</div>
                        </div>
                        <div className="row">
                            <Input
                                value={this.state.phone}
                                handler={this.update('phone')}
                                label={`* ${strings.phone}`}
                                placeholder={strings.patient_phone_placeholder}
                                extraClasses="col-8"
                            />
                            <div className="col-8">{this.showErrors(this.state.validation.phone)}</div>
                        </div>
                        <div className="row">
                            <div className="formInput col-8 qf-address">
                                <label>
                                    * {strings.address} <span
                                    className="qf-small-label-desc">({strings.mailing_purposes_only})</span>
                                    <i className="fa fa-map-marker" aria-hidden="true"/>
                                </label>
                                <Geosuggest
                                    ref={el => (this._geoSuggest = el)}
                                    placeholder={strings.patient_address_placeholder}
                                    initialValue={this.state.address.name}
                                    onSuggestSelect={this.onSuggestSelect}
                                    onBlur={this.updateAddress}
                                    location={new google.maps.LatLng(53.558572, 9.9278215)}
                                    radius="20"
                                />
                                <span style={{
                                    fontStyle: 'italic',
                                    color: '#858585'
                                }}>{strings.select_address_from_suggest_list}</span>
                                <div className="col-8">{this.showErrors(this.state.validation.address)}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3"/>
                                ) : (
                                    <CancelBtn
                                        onclick={this.cancelUserHandler}
                                        title={strings.cancel}
                                        extraClasses="qf-gray-btn w-100 mt-4"
                                    />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="col-11 white-bg px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{color: '#858585'}}/>
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={this.editPatientHandler}
                                        title={strings.edit_patient}
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(EditPatient);



// WEBPACK FOOTER //
// ./src/customModules/Patients/component-edit-patient.js